import View from './PensionWorkflowView';

export default View;
